import React from 'react';

export default () => (
  <section id="signup" className="signup-section">
    <div className="container">
      <div className="row">
        <div className="col-md-10 col-lg-8 mx-auto text-center">
          <i className="far fa-paper-plane fa-2x mb-2 text-white"></i>
          <h2 className="text-white mb-5">
            Tell me about that idea you want to make true!
          </h2>
          <form method="post" netlify-honeypot="bot-field" data-netlify="true">
            <input type="hidden" name="bot-field" />

            <label htmlFor="contact-content">
              <input
                type="text"
                name="Full name"
                className="form-control flex text-grey mb-3"
                id="InputEmail"
                placeholder="Full name*"
                aria-describedby="NameHelp"
                required={true}
              />
            </label>
            <div className="form-group">
              <label>
                <input
                  name="email"
                  id="email"
                  aria-label="email"
                  type="email"
                  placeholder="Email*"
                  className="form-control flex text-grey mb-10"
                  required={true}
                />
              </label>
            </div>
            <div className="form-group">
              <textarea
                name="message"
                aria-label="message"
                id="message"
                rows="8"
                type="text"
                required={true}
                placeholder="Message*"
                className="form-control focus:outline-none focus:shadow-outline"
              ></textarea>
            </div>
            <button type="submit" className="btn btn-primary mx-auto">
              Send message
            </button>
          </form>
        </div>
      </div>
    </div>
  </section>
);
